import { render } from "./McdApp.vue?vue&type=template&id=6a8aa215&scoped=true"
import script from "./McdApp.vue?vue&type=script&lang=js"
export * from "./McdApp.vue?vue&type=script&lang=js"

import "./McdApp.vue?vue&type=style&index=0&id=6a8aa215&scoped=true&lang=css"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8aa215"]])

export default __exports__